import axios from 'axios';

const { REACT_APP_ESTEIRA_BACK } = process.env;

export default class DiagramaService {
  axios: any;

  constructor() {
    this.axios = axios.create({
      baseURL: REACT_APP_ESTEIRA_BACK + '/rest/diagramas'
    });
    
    this.axios.interceptors.request.use((config: any) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });
  }

  async getDiagramaPorModelo(idModelo: number | string) {
    try {
        const { data } = await this.axios.get(`/${idModelo}`);
        return data; 
    } catch (error) {
        console.error("Erro ao buscar diagrama:", error);
        throw error; 
    }
  };
}